import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.css'],
  imports: [RouterLink]
})
export class ErrorpageComponent  {

  constructor() { }

 

}
